// Read a REACT_APP_* variable from the runtime config injected by the
// container entrypoint (window.__env), falling back to the build-time
// process.env for local development.
const env = (key) => (window.__env && window.__env[key]) || process.env[key];

export default env;
